

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { BillingProfileSetup } from "../../components/BillingProfileSetup";
import { TaxProfileAssignment } from "../../components/BillingProfileAssociationSetup";


export const BillingProfileAssociationSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Billing Profile Association"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Billing Profile Association Setup", navigateTo: "/billing-profile-association" }
      ]}
      mainContents={<TaxProfileAssignment testId="tax-profile-setup"/>}
    />
  );
};

